/** Explicit additional rental-tax cash assumptions, never payments or tax-law rules. */
export type TaxAdvances = { confirmed: boolean; payments: { year: number | null; month: number | null; amount: number | null }[] };
const object = (value: unknown): value is Record<string, unknown> => !!value && typeof value === 'object' && !Array.isArray(value);
const integer = (value: unknown, low: number, high: number) => typeof value === 'number' && Number.isInteger(value) && value >= low && value <= high;
export function validTaxAdvances(value: unknown): value is TaxAdvances | undefined {
  if (value === undefined) return true;
  return object(value) && Object.keys(value).length === 2 && typeof value.confirmed === 'boolean'
    && Array.isArray(value.payments) && value.payments.length <= 360 && value.payments.every(payment => object(payment)
      && Object.keys(payment).length === 3 && ['year', 'month', 'amount'].every(key => Object.hasOwn(payment, key))
      && (payment.year === null || integer(payment.year, 2000, 2139))
      && (payment.month === null || integer(payment.month, 1, 12))
      && (payment.amount === null || typeof payment.amount === 'number' && Number.isFinite(payment.amount)
        && payment.amount >= 0 && payment.amount <= 100000000 && payment.amount === Number(payment.amount.toFixed(2))));
}
export function taxAdvanceSchedule(groups: { id: string; title: string; taxAdvances?: TaxAdvances }[], startYear: number | null | undefined, years: number) {
  const payments: { assessmentId: string; assessmentTitle: string; year: number; month: string; amountCents: number }[] = [];
  const problems: string[] = [];
  for (const group of groups) {
    const plan = group.taxAdvances;
    if (plan === undefined) continue;
    if (!validTaxAdvances(plan) || !plan.confirmed || plan.payments.length === 0) { problems.push(group.title); continue; }
    let incomplete = false;
    for (const payment of plan.payments) {
      if (payment.year === null || payment.month === null || payment.amount === null || startYear == null
        || payment.year < startYear || payment.year >= startYear + years) { incomplete = true; continue; }
      payments.push({ assessmentId: group.id, assessmentTitle: group.title, year: payment.year,
        month: `${payment.year}-${String(payment.month).padStart(2, '0')}`, amountCents: Math.round(payment.amount * 100) });
    }
    if (incomplete) problems.push(group.title);
  }
  return { enabled: groups.some(group => group.taxAdvances !== undefined), ready: problems.length === 0, payments, problems };
}
